import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";

export default function Unsubscribed() {
    const [params] = useSearchParams();
    const ok = params.get("ok") === "1";
    return (
        <main className="min-h-[60vh] bg-slate-50 flex items-center justify-center px-4" data-testid="unsubscribed-page">
            <div className="bg-white rounded-2xl border border-slate-200 p-10 max-w-md w-full text-center">
                {ok ? (
                    <>
                        <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto mb-4" />
                        <h1 className="font-heading text-2xl font-extrabold text-slate-900 mb-2" data-testid="unsubscribed-heading">
                            You've been unsubscribed
                        </h1>
                        <p className="text-slate-500 text-sm mb-6">
                            You won't receive marketing emails from Freddie's anymore. Order updates for any purchases still come through — those are about your orders, not marketing.
                        </p>
                    </>
                ) : (
                    <>
                        <XCircle className="h-12 w-12 text-amber-500 mx-auto mb-4" />
                        <h1 className="font-heading text-2xl font-extrabold text-slate-900 mb-2">Link not recognised</h1>
                        <p className="text-slate-500 text-sm mb-6">
                            This unsubscribe link didn't match a subscription — you may already be unsubscribed.
                        </p>
                    </>
                )}
                <Link to="/" data-testid="unsubscribed-home-link" className="text-[#0033A0] font-bold hover:underline text-sm">
                    Back to the shop
                </Link>
            </div>
        </main>
    );
}
